import { getAcquiringTerms } from './banks/acquiring.js';
import { getBankGuaranteesTerms } from './banks/bankGuarantees.js';
import { getBukhgalteriyaDlyaBiznesaTerms } from './banks/bukhgalteriyaDlyaBiznesa.js';
import { getBusinessCreditsConditions } from './banks/businessCredits.js';
import { getBusinessDepositTerms } from './banks/businessDeposit.js';
import { getBiznesRegistrationTerms } from './banks/businessRegistration.js';
import { getBusinessRkoTerms } from './banks/businessRko.js';
import { getCreditCardsTerms } from './banks/creditCards.js';
import { getCreditsTerms } from './banks/credits.js';
import { getDebitCardsTerms } from './banks/debitCards.js';
import { getLeasingTerms } from './banks/leasing.js';
import { getMortgageTerms } from './banks/mortgage.js';
import { getSavingsTerms } from './banks/savings.js';
import { getBiznesNaMarketpleysakhTerms } from './educationalOrganization/biznesNaMarketpleysakh.js';
import { getEducationalTypeTerms } from './educationalOrganization/educationalType.js';
import { getCriticalIllnessTerms } from './insuranceCompany/criticalIllness.js';
import { getHealthInsuranceTerms } from './insuranceCompany/healthInsurance.js';
import { getHomeInsuranceTerms } from './insuranceCompany/homeInsurance.js';
import { getStrakhovaniyeOtUkusaKleshchaTerms } from './insuranceCompany/strakhovaniyeOtUkusaKleshcha.js';
import { getMicrocreditsTerms } from './mfi/microcredits.js';
import { getAccumulativeDepositTerms } from './other/accumulativeDeposit.js';
import { getBankrotstvoTerms } from './other/bankrotstvo.js';
import { getBiznesVedTerms } from './other/biznesVed.js';
import { getBrokerTerms } from './other/broker.js';
import { getZarplatnyjProektTerms } from './other/zarplatnyjProekt.js';

const methodsMap = {
    //banks
    savings: getSavingsTerms,
    debitCards: getDebitCardsTerms,
    creditCards: getCreditCardsTerms,
    credits: getCreditsTerms,
    mortgage: getMortgageTerms,
    leasing: getLeasingTerms,
    businessRko: getBusinessRkoTerms,
    businessDeposit: getBusinessDepositTerms,
    businessCredits: getBusinessCreditsConditions,
    acquiring: getAcquiringTerms,
    biznesRegistration: getBiznesRegistrationTerms,
    bankGuarantees: getBankGuaranteesTerms,
    bukhgalteriyaDlyaBiznesa: getBukhgalteriyaDlyaBiznesaTerms,
    // insuranceCompany
    homeInsurance: getHomeInsuranceTerms,
    criticalIllness: getCriticalIllnessTerms,
    strakhovaniyeOtUkusaKleshcha: getStrakhovaniyeOtUkusaKleshchaTerms,
    healthInsurance: getHealthInsuranceTerms,
    // educationalOrganization
    educationalType: getEducationalTypeTerms,
    biznesNaMarketpleysakh: getBiznesNaMarketpleysakhTerms,
    // mfo
    microcredits: getMicrocreditsTerms,
    // other (не услуги/теги отзывов)
    biznesVed: getBiznesVedTerms,
    broker: getBrokerTerms,
    accumulativeDeposit: getAccumulativeDepositTerms,
    bankrotstvo: getBankrotstvoTerms,
    zarplatnyjProekt: getZarplatnyjProektTerms,
};
const getCommonProductTerms = (serviceKey) => {
    return methodsMap[serviceKey];
};

export { getCommonProductTerms };
//# sourceMappingURL=index.js.map
